const isEmpty = (str: string) => {
  return (!str || str.length === 0 || str === "");
}

export default isEmpty;